import React, { forwardRef } from "react";
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';
import BaseModal from "../Modals/BaseModal";
import Picture from "../Picture";

interface IChecklistItemModalProps extends IBuildrProps {
    modalId: string;
    modalImage: string;
    modalAlt: string;
    modalText: string;
    modalTitle: string;
}

export default styled(forwardRef((props: IChecklistItemModalProps, ref: any) => {
    const { editorClassObj, className, modalImage, modalAlt = "", modalText, modalTitle, modalId } = props;

    return (
        <BaseModal ref={ref} className={cx(className, editorClassObj)} modalId={modalId}>
            <div className="checklist-modal-content">
                <Picture className="modal-image" src={`${process.env.GATSBY_MEDIA_URL || ""}${modalImage}`} alt={modalAlt || modalTitle} />
                <h2 className="modal-title">{modalTitle}</h2>
                <div className="modal-text">{modalText}</div>
            </div>
        </BaseModal>
    );

}))`
    .checklist-modal-content {
        text-align: center;
        padding: 0px 2rem;
        max-width: 685px;
        margin: auto;
    }
    .modal-title {
        font-family: ${props => props.theme.fontFamilySansSerif};
        text-align: left;
    }
    .modal-text {
        text-align: left;
    }
    .modal-image {
        max-width: 100%;
    }
`;
